<div class="message-filter-panel">
  <div class="panel-header">
    <div class="panel-title">{{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.TITLE' | translate }}</div>
    <div
      class="close-button clickable"
      role="button"
      tabindex="0"
      (click)="close()"
      (keydown.enter)="close()"
      (keydown.space)="$event.preventDefault(); close()"
    >
      <i class="fa fa-times fa-fw"></i>
    </div>
  </div>

  <div class="form-group">
    <label>{{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.SENDER' | translate }}</label>
    <div
      class="sender-row form-control clickable"
      role="button"
      tabindex="0"
      (click)="openSenderPicker()"
      (keydown.enter)="openSenderPicker()"
      (keydown.space)="$event.preventDefault(); openSenderPicker()"
    >
      <span class="sender-summary" *ngIf="draftUsers.length === 0">
        {{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.SENDER_ALL' | translate }}
      </span>
      <span class="sender-summary" *ngIf="draftUsers.length > 0 && draftUsers.length <= 2">
        {{ getSenderNames() }}
      </span>
      <span class="sender-summary" *ngIf="draftUsers.length > 2">
        {{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.SENDER_COUNT' | translate : { COUNT: draftUsers.length } }}
      </span>
      <i class="fa fa-angle-right fa-fw"></i>
    </div>
  </div>

  <div class="form-group">
    <label>{{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.DATE_RANGE' | translate }}</label>
    <div class="date-range-pickers">
      <div class="date-picker">
        <input type="text"
          class="form-control"
          name="message-filter-date-from"
          [placeholder]="'WEBCLIENT.CHAT.MESSAGE_FILTER.DATE_FROM' | translate"
          bsDatepicker
          [bsConfig]="dateInputConfig"
          [(ngModel)]="draftDateFrom"
          (ngModelChange)="onDateChanged()">
      </div>
      <div class="date-to">
        {{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.DATE_TO' | translate }}
      </div>
      <div class="date-picker">
        <input type="text"
          class="form-control"
          name="message-filter-date-to"
          [placeholder]="'WEBCLIENT.CHAT.MESSAGE_FILTER.DATE_TO' | translate"
          bsDatepicker
          [bsConfig]="dateInputConfig"
          [(ngModel)]="draftDateTo"
          (ngModelChange)="onDateChanged()">
      </div>
    </div>
    <div class="invalid-date-range text-danger" *ngIf="isInvalidDateRange">
      {{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.INVALID_DATE_RANGE' | translate }}
    </div>
  </div>

  <div class="panel-actions">
    <button type="button" class="btn btn-default" (click)="clear()">
      {{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.CLEAR' | translate }}
    </button>
    <button type="button" class="btn tn-button-primary" (click)="apply()">
      {{ 'WEBCLIENT.CHAT.MESSAGE_FILTER.APPLY' | translate }}
    </button>
  </div>
</div>
